import { useCallback, useEffect, useState } from 'react'

import Cookies from 'js-cookie'

export const GS_VISIBILITY = 'gs_visibility'
export const SURVEY_VISIBILITY = 'survey_visibility'

export default function useVisibilityCookie(cookieString: string) {
  const [isVisible, setVisible] = useState(JSON.parse(Cookies.get(cookieString) || 'true'))

  useEffect(() => {
    const visibilityCookie = Cookies.get(cookieString)
    if (!visibilityCookie) {
      Cookies.set(cookieString, 'true')
      return
    }
    visibilityCookie === 'true' ? setVisible(true) : setVisible(false)
  }, [])

  const toggleVisiblity = useCallback((visibility: boolean) => {
    if (visibility) {
      Cookies.set(cookieString, 'true')
      setVisible(true)
    } else {
      Cookies.set(cookieString, 'false')
      setVisible(false)
    }
  }, [])

  return [isVisible, toggleVisiblity]
}
